var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentsData.type == 6)?_c('div',{style:(`
        padding: ${_vm.componentsData.content.marginData.top}px ${_vm.componentsData.content.marginData.left}px; background: ${_vm.componentsData.content.bg_color};
        border-radius: ${_vm.componentsData.content.marginData.topRadius}px ${_vm.componentsData.content.marginData.topRadius}px ${_vm.componentsData.content.marginData.bottomRadius}px ${_vm.componentsData.content.marginData.bottomRadius}px;
    `)},[_c('div',{style:(_vm.componentsData.content.height_id == 1
                ? 'height: 375px;'
                : _vm.componentsData.content.height_id == 2
                ? 'height: 187.5px;'
                : _vm.componentsData.content.height_id == 3
                ? 'height: 281.25px;'
                : _vm.componentsData.content.height_id == 4
                ? 'height: 500px;'
                : _vm.componentsData.content.height_id == 5
                ? 'height: 750px;'
                : 'height: 375px;')},[_c('video',{staticClass:"w100",attrs:{"src":_vm.componentsData.content.videoList.picview}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }